import { User } from '../../models/User';
import { useState } from 'react';
import { UserTable } from './UserTable';
import { SearchIcon } from '@heroicons/react/solid';

interface ContactsSectionProps {
  users: User[];
  isAdmin: boolean;
  isContactsLoaded: boolean;
}

export const ContactsSection = (props: ContactsSectionProps) => {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="p-8 sm:p-12">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-6 mb-10">
        <div>
          <h1 className="text-3xl sm:text-5xl font-black tracking-tighter dark:text-white text-slate-900 uppercase">Directory</h1>
          <p className="text-slate-500 dark:text-slate-400 font-bold text-sm uppercase tracking-widest mt-1">Mitchell Family & Advisors</p>
        </div>
      </div>

      <div className="mb-10 relative group">
        <input
          type="text"
          placeholder="Search family..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full p-4 pl-12 rounded-2xl border border-slate-200 dark:border-white/5 bg-white dark:bg-slate-800/40 text-slate-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition-all shadow-xl placeholder:text-slate-400 dark:placeholder:text-slate-500 font-bold text-base"
        />
        <SearchIcon className="h-5 w-5 absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400 group-focus-within:text-blue-500 transition-colors" />
      </div>

      <UserTable 
        users={props.users} 
        isAdmin={props.isAdmin} 
        isContactsLoaded={props.isContactsLoaded} 
        searchQuery={searchQuery} 
      />
    </div>
  );
};
